import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree} from '@angular/router';
import {Observable} from 'rxjs';
import {AuthenticationService} from "../services/authentication.service";
import {RoleService} from "../services/role.service";
import {ProdDialogService, ProdDialogData, ProdDialogType} from 'prod-dialog';
import {ChangePasswordComponent} from "../components/change-password/change-password.component";

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(private router: Router, private authenticationService: AuthenticationService, private roleService: RoleService, private dialogService: ProdDialogService) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const params = route.queryParams;
    if (params['user'] && params['token']) return true;

    const currentUser = this.authenticationService.currentUserValue;

    if (currentUser && currentUser.requireChangePassword) {
      this.dialogService.open(new ProdDialogData({
        component: ChangePasswordComponent,
        type: ProdDialogType.FORM,
        disableClose: true,
        data: {isRequired: true}
      }))
    }

    if (currentUser && localStorage.getItem('jwt_token') && localStorage.getItem('current_user')) {
      return this.checkUserRole(route);
    }

    this.router.navigate(['/login']).then(() => window.location.reload());
    return false;
  }

  checkUserRole(route: ActivatedRouteSnapshot): boolean {
    if (route.data && route.data['role']) {
      return this.roleService.hasRole(route.data['role']);
    }

    return true;
  }
}
